import React from 'react';
import useFetchPublicApiKey from './utils/fetchPublicKey';

import "./assets/css/util.scss"
import "./styles/layout.scss"
import "./styles/my.scss"
// Shared stylesheets belong in the global bundle, not inside a lazy module chunk: imported
// per-component they either load in a conflicting order between chunks (and get dropped) or
// simply never reach a route that needed them.
import "./styles/flatPicker.scss"
import "./assets/css/threedotloading.scss"
import "./pages/CustomComponent/DataTable/columnSelector.scss"
// Theme tokens + dark overrides. Imported last so that, on a specificity tie, a dark rule
// wins over the stylesheet it is re-skinning. Light mode matches none of it.
import "./styles/theme/theme.scss"
// import "./styles/style/scss/core.scss"
import Router from './router/Router';
import { ThemeProvider } from './theme/ThemeProvider';

const App = () => {
  // console.log(window.location.origin);
  if (window.location.hash === "#/login") {
    // dispatch(setSessionData())
    // dispatch(setPublicKey())
    // localStorage.clear();
  }
  // useFetchPublicApiKey()
  const DisbaleConsole = () => {

    if (window.location.origin !== "https://avdhaan.gas.polarisgrids.com") {
      return;
    }

    let logging = null;

    if (typeof localStorage != 'undefined' && typeof Storage !== 'undefined' && localStorage) {
      logging = localStorage.getItem('logging');
    }
    if (logging == null) {
      window.console.log = function () { };   // disable any console.log debugging statements 
      // window.console.error = function () { } // disable any console.error 
    }
  }

  DisbaleConsole()
  return (

    // <HashRouter>
    //   <Routes>
    //     <Route path="/" element={<Login />} />
    //     {/* <Route
    //       path="utility/sbpdcl/hes"
    //       element={<LayoutWrapper children={<SBPDCLUtility />} />}
    //     /> */}
    //     {/* <Route path="/" element={<div></div>} /> */}

    //     <Route
    //       path="utility/lpdd/hes"
    //       element={<LayoutWrapper children={<LPDDUtility />} />}
    //     />
    //     {/* {/* <Route
    //       path="utility/sbpdcl/hes"
    //       element={<LayoutWrapper children={<HesUtility />} />}
    //     /> */}

    //     <Route path="forgot-password" element={<ForgotPassword />} />
    //     <Route path="home" element={<Home />} />
    //   </Routes>
    // </HashRouter>
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
};

export default App;
